import tw from 'twin.macro';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/base';

import Markdown from '../completed/components/Markdown';

const NoAccess = ({ email }: { email?: string | null }) => {
  const { t } = useTranslation();

  return (
    <section tw="grid min-h-screen place-items-center">
      <div tw="mx-auto max-w-screen-xl py-8 px-4 lg:(py-16 px-6)">
        <div tw="mx-auto max-w-screen-sm text-center">
          <h1 tw="mb-4 font-extrabold text-3xl tracking-tight md:text-4xl">
            {t('noAccess.title', { defaultValue: 'ไม่มีสิทธิ์ใช้งาน' })}
          </h1>
          {email && (
            <p tw="mb-2 font-light text-lg text-gray-500">
              {t('noAccess.description', {
                email,
                defaultValue: 'บัญชี {{email}} ยังไม่ได้รับสิทธิ์เข้าใช้งานระบบนี้',
              })}
            </p>
          )}
          <div tw="mb-8 flex justify-center text-gray-700">
            <Markdown
              text={t('noAccess.contactMarkdown', {
                defaultValue: 'กรุณาติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์การใช้งาน',
              })}
            />
          </div>
          <Button as="a" href="/logout">
            {t('noAccess.logoutButton', { defaultValue: 'ออกจากระบบ / ใช้บัญชีอื่น' })}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NoAccess;
